import SetupMFAStep from '../../components/SetupMFAStep'
import SetupMFAWebAuthnRegisterAnimation from '../../components/SetupMFAWebAuthnRegisterAnimation'
import {
  FINISH,
  NEXT,
  SETUP_MFA_WEB_AUTHN_FOOTNOTE,
  SETUP_MFA_WEB_AUTHN_MESSAGE_REGISTER_STEP,
  SETUP_MFA_WEB_AUTHN_MESSAGE_START_REGISTRATION_STEP,
  SETUP_MFA_WEB_AUTHN_TITLE,
} from '../../constants/ui.labels'
import Image from '@talkdesk/cobalt-react-image'
import Card from '@talkdesk/cobalt-react-card'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'

/** @param {{ learnMoreAboutSecurityKeysUrl?: any, [key: string]: any }} props */
const SetupMFAWebAuthnStep = ({ learnMoreAboutSecurityKeysUrl, ...props }) => (
  <SetupMFAStep
    title={SETUP_MFA_WEB_AUTHN_TITLE}
    footnoteLabel={SETUP_MFA_WEB_AUTHN_FOOTNOTE}
    footnoteUrl={learnMoreAboutSecurityKeysUrl}
    {...props}
  />
)

/** @param {{ onPrepareRegistration?: any, securityKeyUrl?: any, [key: string]: any }} props */
export const StartRegistrationStep = ({
  onPrepareRegistration,
  securityKeyUrl,
  ...otherProps
}) => (
  <SetupMFAWebAuthnStep
    subtitle={SETUP_MFA_WEB_AUTHN_MESSAGE_START_REGISTRATION_STEP}
    boxContent={
      <Card outlined>
        <Box paddingX='5' paddingY='12' width='100%'>
          <Flex direction='column' alignX='center' alignY='center' gap='5'>
            <Image src={securityKeyUrl} width={100} alt='' />
          </Flex>
        </Box>
      </Card>
    }
    buttonLabel={NEXT}
    buttonAction={onPrepareRegistration}
    {...otherProps}
  />
)

/** @param {{ onFinishRegistration?: any, isValid?: any, securityKeyAnimationUrl?: any, [key: string]: any }} props */
export const RegisterStep = ({
  onFinishRegistration,
  isValid,
  securityKeyAnimationUrl,
  ...otherProps
}) => (
  <SetupMFAWebAuthnStep
    subtitle={SETUP_MFA_WEB_AUTHN_MESSAGE_REGISTER_STEP}
    boxContent={
      <Card outlined>
        <Box paddingX='5' paddingY='2' width='100%'>
          <Flex direction='column' alignX='center' alignY='center' gap='5'>
            <SetupMFAWebAuthnRegisterAnimation
              isValid={isValid}
              securityKeyAnimationUrl={securityKeyAnimationUrl}
            />
          </Flex>
        </Box>
      </Card>
    }
    buttonLabel={FINISH}
    buttonAction={onFinishRegistration}
    buttonDisabled={!isValid}
    {...otherProps}
  />
)
